import React, { useEffect } from 'react';
import { View, Platform, Pressable } from 'react-native';
import { useTheme } from '@/context/ThemeContext';
import { isDarkTheme } from '@/constants/Colors';
import Text from '@/components/Typography/Text';
import Icon from '@/components/Icon';
import { useLanding } from '@/components/Landing/LandingKit';
import useResponsiveness from '@/hooks/useResponsiveness';

export default function DocsSearchButton({ onPress, label = "Search documentation", placeholder = "Search docs..." }) {
  const { colors, theme } = useTheme();
  const { isXS } = useResponsiveness();
  const isDark = isDarkTheme(theme);
  const { c } = useLanding();

  useEffect(() => {
    if (Platform.OS !== 'web') return;

    const handleKeyDown = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        e.preventDefault();
        onPress();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onPress]);

  return (
    <Pressable
      onPress={onPress}
      accessibilityRole="button"
      accessibilityLabel={label}
      style={({ hovered }) => ({
        flexDirection: 'row',
        alignItems: 'center',
        gap: 10,
        paddingHorizontal: 14,
        paddingVertical: 8,
        borderRadius: 6,
        borderWidth: 1,
        minWidth: isXS ? 40 : 240,
        minHeight: 40,
        borderColor: c.rule,
        backgroundColor: hovered ? c.panel : 'transparent',
      })}
    >
      <Icon
        name="magnifying-glass"
        size={14}
        color={colors.text_color_secondary}
      />
      {!isXS && (
        <>
          <Text tag="span" size="m" color="secondary" style={{ flex: 1 }}>
            {placeholder}
          </Text>
          <View
            style={{
              paddingHorizontal: 6,
              paddingVertical: 2,
              borderRadius: 4,
              backgroundColor: isDark
                ? 'rgba(255,255,255,0.08)'
                : 'rgba(0,0,0,0.06)',
            }}
          >
            <Text tag="kbd" size="n" color="tertiary">
              ⌘K
            </Text>
          </View>
        </>
      )}
    </Pressable>
  );
}
